var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-wrapper"},[_c('input',{attrs:{"type":"text","placeholder":_vm.$tc('user.filter.name')},domProps:{"value":_vm.search},on:{"input":_vm.inputHandler}})])
}
var staticRenderFns = []

export { render, staticRenderFns }